import { Component, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
  App,
  NavController,
  ModalController,
  NavParams,
  ToastController,
  Platform
} from "ionic-angular";
import { CategoryModel } from "../../../../providers/categories/categories";
import { LoaderProvider } from "../../../../providers/loader/loader";
import {
  MyPicsListModel,
  PrivateProfile,
  UserProvider
} from "../../../../providers/user/user";
import {
  BackgroundModel,
  SinleValueModel,
  TextValueModel
} from "../../../../providers/value/value";
import { MeSettingsSportartsPage } from "../me-settings-sportarts/me-settings-sportarts";
import { PrivateProfilePhotosPage } from "../private-profile-photos/private-profile-photos";
import { SessionProvider } from "../../../../providers/session/session";
import { ConfigProvider } from "../../../../providers/config/config";
import { NewsProvider, PagerModel } from "../../../../providers/news/news";
import { NotificationPage } from "../../../notification/main/notification";
import { ResultSearchPage } from "../../../results/result-search/result-search";
import { Device } from "@ionic-native/device";
import { AppDetectorProvider } from "../../../../providers/detector/detector";

/**
 * Generated class for the PrivateProfilePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: "page-private-profile",
  templateUrl: "private-profile.html"
})
export class PrivateProfilePage {
  @ViewChild("uploadButton")
  uploadButton: any;

  profileBackup: PrivateProfile;
  profile: PrivateProfile;
  titles: SinleValueModel[] = [];
  types: SinleValueModel[] = [];
  categories: CategoryModel[] = [];
  photos: MyPicsListModel[] = [];
  countries: TextValueModel[] = [];
  backgrounds: BackgroundModel[] = [];
  birthDay: string;
  activeTop: string = "preview";

  isPostbonnApp: boolean = false;
  isVivawestApp: boolean = false;
  isEmployeeDHL: boolean = false;
  readOnly: boolean = false;
  private toast = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public app: App,
    public translate: TranslateService,
    public userService: UserProvider,
    public loadingCtrl: LoaderProvider,
    public modalCtrl: ModalController,
    private sessionService: SessionProvider,
    private toastCtrl: ToastController,
    private config: ConfigProvider,
    private newsService: NewsProvider,
    private device: Device,
    private appDetector: AppDetectorProvider,
    private platform: Platform,
  ) {
    this.appVerification();

    this.profileBackup = navParams.data.data.profile;
    this.profile = JSON.parse(JSON.stringify(this.profileBackup));
    if (this.profile.birthday && this.profile.birthday !== -1) {
      this.birthDay = this.profile.birthday == 0 ? "" : new Date(this.profile.birthday).toISOString();
    }
    this.isEmployeeDHL = (this.profile.clubName.includes("Deutsche Post DHL Group")) ? true : false;
    this.titles = navParams.data.data.titles;
    this.types = navParams.data.data.types;
    this.categories = navParams.data.data.categories;
    this.photos = navParams.data.data.photos;
    this.countries = navParams.data.data.countries;
    this.backgrounds = navParams.data.data.backgrounds;
    this.readOnly = navParams.data.data.readOnly;
    this.profile.status = this.profile.status.length > 0 ? this.profile.status : this.types[0].value;
  }

  async appVerification() {
    let name: string = (await this.config.config).appId;

    this.isPostbonnApp = name.toLocaleLowerCase().includes("postbonn");
    this.isVivawestApp = name.toLocaleLowerCase().includes("vivawest");

    console.log('isVivawestApp: ' + this.isVivawestApp);
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad PrivateProfilePage");
  }

  employeeCheckboxEvent() {
    this.profile.clubName = (this.isEmployeeDHL) ? "Deutsche Post DHL Group" : "";
    this.save(false);
    if (this.isEmployeeDHL) this.fireMessage(this.translate.instant('PRIVATE_DHL_POLICY'));
  }

  fireMessage(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 7000,
      position: "top"
    })
    toast.present();
  }

  // openSportarts() {
  // let sportartModal = this.modalCtrl.create(MeSettingsSportartsPage, {
  //   data: { categories: this.categories, picked: this.profile.sportTypesVec }
  // });
  // sportartModal.present();

  // (this.app.getRootNav() as NavController).push(MeSettingsSportartsPage, { data: { categories: this.categories, picked: this.profile.sportTypesVec } })
  // }

  checkForm() {
    let hasError = false;
    let text = "";

    if (
      !this.profile.forName ||
      this.profile.forName.length === 0 ||
      !this.profile.surName ||
      this.profile.surName.length === 0
    ) {
      hasError = true;
      text +=
        this.translate.instant("PRIVATEPROFILE_FILL_THE_FORM_FIRST") + "\n";
    }
    /*if (!this.profile.anrede || this.profile.anrede.length === 0) {
      hasError = true;
      text += this.translate.instant("GLOBAL_ERROR_X_IS_REQUIRED", { name: this.translate.instant("PRIVATEPROFILE_TITLE") }) + "\n";
    }
    if (!this.profile.city || this.profile.city.length === 0) {
      hasError = true;
      text += this.translate.instant("GLOBAL_ERROR_X_IS_REQUIRED", { name: this.translate.instant("PRIVATEPROFILE_CITY") }) + "\n";
    }
    if (!this.profile.sportTypesVec || this.profile.sportTypesVec.length === 0) {
      hasError = true;
      text += this.translate.instant("GLOBAL_ERROR_AT_LEAST_X_Y_IS_REQUIRED", { count: 1, name: this.translate.instant("PRIVATEPROFILE_MY_SPORTART") }) + "\n";
    }
    if (!this.profile.status || this.profile.status.length === 0) {
      hasError = true;
      text += this.translate.instant("GLOBAL_ERROR_X_IS_REQUIRED", { name: this.translate.instant("PRIVATEPROFILE_PROFILE_TYPE") }) + "\n";
    }
    if (!this.profile.zip || this.profile.zip.length === 0) {
      hasError = true;
      text += this.translate.instant("GLOBAL_ERROR_X_IS_REQUIRED", { name: this.translate.instant("PRIVATEPROFILE_ZIP") }) + "\n";
    }
    if (!this.profile.forName || this.profile.forName.length === 0) {
      hasError = true;
      text += this.translate.instant("GLOBAL_ERROR_X_IS_REQUIRED", { name: this.translate.instant("PRIVATEPROFILE_FIRST_NAME") }) + "\n";
    }
    if (!this.profile.surName || this.profile.surName.length === 0) {
      hasError = true;
      text += this.translate.instant("GLOBAL_ERROR_X_IS_REQUIRED", { name: this.translate.instant("PRIVATEPROFILE_LAST_NAME") }) + "\n";
    }
*/
    if (hasError) {
      this.toastCtrl
        .create({
          message: text,
          duration: 6000,
          showCloseButton: true
        })
        .present();
    }

    return !hasError;
  }

  async save(exitTrigger: boolean = true) {
    console.log('save');
    let loader = this.loadingCtrl.create({
      content: this.translate.instant("GLOBAL_LOADING")
    });
    loader.present();

    if (this.checkForm()) {
      if (this.birthDay) {
        this.profile.birthday = new Date(this.birthDay).getTime();
      } else {
        this.profile.birthday = -1;
      }

      this.profile.phoneType = this.device.platform + " " + this.device.version;

      this.userService.updateProfile(this.profile);

      // if (prof && typeof prof != undefined) {
      this.sessionService.profile.id = this.profile.id;
      this.sessionService.profile.area = this.profile.area;
      this.sessionService.profile.anrede = this.profile.anrede;
      if (this.profile.birthday && this.profile.birthday !== -1)
        this.sessionService.profile.birthday = this.profile.birthday;
      this.sessionService.profile.city = this.profile.city;
      this.sessionService.profile.country = this.profile.country;
      this.sessionService.profile.profilePicLink = this.profile.profilePicLink;
      this.sessionService.profile.status = this.profile.status;
      this.sessionService.profile.themeName = this.profile.themeName;
      this.sessionService.profile.zip = this.profile.zip;
      this.sessionService.profile.forName = this.profile.forName;
      this.sessionService.profile.surName = this.profile.surName;
      this.sessionService.profile.clubName = this.profile.clubName;
      this.sessionService.profile.phoneType = this.profile.phoneType;


      let it = this.photos.find(
        x => x.imageLink === this.profile.profilePicLink
      );
      if (it && it.id) {
        let succ = await this.userService.updateProfilePicture(it.id);
        if (succ) {
          if (!it)
            this.sessionService.profile.profilePicLink = this.profile.profilePicLink;
        }
      }
      if (exitTrigger) {
        if ((this.app.getRootNav() as NavController).canGoBack())
          (this.app.getRootNav() as NavController).pop().then(() => {
            loader.dismiss();
          });
        else
          this.navCtrl.pop().then(() => loader.dismiss())
      } else {
        loader.dismiss();
      }
    } else {
      loader.dismiss();
    }
  }
  getCover(cover: string) {
    if(this.profile.themeName ==='spooorts.de') this.profile.themeName = 'blue-curtain';
    return (cover) ? this.backgrounds.find(x => x.value === cover).img : "";
  }

  get getInitialSlide() {
    let theme = this.backgrounds.findIndex(x => x.value == this.profile.themeName);
    return theme == -1 ? 4 : theme;
  }
  chooseCover() {
    this.activeTop = "cover";
  }
  presentToast(message, position, cssclass) {
    if (this.toast) {
      this.toast.dismiss();
      this.toast = null;
    }
    this.toast = this.toastCtrl.create({
      message: message,
      cssClass: cssclass,
      position: position,
      duration: 10000
    });
    this.toast.present();
  }
  uploadPhoto() {
    const allowed = localStorage.getItem('isPhotoUploadAllowedKey')
		if (!allowed && this.platform.is('android') ){
      this.presentToast(this.translate.instant("IMAGE_DENIED"),'bottom', "permission-sheet");
    }else{
      (this.app.getRootNav() as NavController).push(PrivateProfilePhotosPage, {
        data: { pictures: this.photos, profile: this.profile }
      });
    }
    /*
    this.activeTop = "photo";
    setTimeout(() => {
      this.createFileInput();
    });
    */
  }

  selectBg(bg: BackgroundModel) {
    this.profile.themeName = bg.value;
    this.activeTop = "preview";
  }
}



// WEBPACK FOOTER //
// /src/pages/me/settings/private-profile/private-profile.ts